import * as React from "react";
import type { SVGProps } from "react";
const SvgXOctagon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.86 2V1a1 1 0 0 0-.707.293zm8.28 0 .707-.707A1 1 0 0 0 16.14 1zM22 7.86h1a1 1 0 0 0-.293-.707zm0 8.28.707.707A1 1 0 0 0 23 16.14zM16.14 22v1a1 1 0 0 0 .707-.293zm-8.28 0-.707.707A1 1 0 0 0 7.86 23zM2 16.14H1a1 1 0 0 0 .293.707zm0-8.28-.707-.707A1 1 0 0 0 1 7.86zm13.707 1.847a1 1 0 0 0-1.414-1.414zm-7.414 4.586a1 1 0 1 0 1.414 1.414zm1.414-6a1 1 0 0 0-1.414 1.414zm4.586 7.414a1 1 0 0 0 1.414-1.414zM7.86 3h8.28V1H7.86zm7.573-.293 5.86 5.86 1.414-1.414-5.86-5.86zM21 7.86v8.28h2V7.86zm.293 7.573-5.86 5.86 1.414 1.414 5.86-5.86zM16.14 21H7.86v2h8.28zm-7.573.293-5.86-5.86-1.414 1.414 5.86 5.86zM3 16.14V7.86H1v8.28zm-.293-7.573 5.86-5.86-1.414-1.414-5.86 5.86zm11.586-.274-6 6 1.414 1.414 6-6zm-6 1.414 6 6 1.414-1.414-6-6z"
    />
  </svg>
);
export default SvgXOctagon;
